import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, TextField, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import theme from 'theme'

const ConfirmationDialog = ({
  open,
  setOpen,
  feedback,
  setFeedbackSubmitted,
  handleSubmit = async () => {},
}) => {
  const [messageFeedback, setMessageFeedback] = useState('')
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const { POSITIVE_FEEDBACK_VARIANT, NEGATIVE_FEEDBACK_VARIANT } =
    constants.dai.general

  const isPositiveFeedback = feedback === POSITIVE_FEEDBACK_VARIANT

  const handleChangeFeedback = (event) => setMessageFeedback(event.target.value)

  const onSubmit = async () => {
    try {
      setLoading(true)

      const daiFeedback = {
        rate: isPositiveFeedback
          ? POSITIVE_FEEDBACK_VARIANT
          : NEGATIVE_FEEDBACK_VARIANT,
        reason: messageFeedback,
      }

      await handleSubmit(daiFeedback)

      snackbar.open({
        message: 'Avaliação enviada com sucesso!',
        variant: 'success',
      })
      setMessageFeedback('')
      setFeedbackSubmitted(feedback)
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title={`Avaliar ${
        isPositiveFeedback ? 'positivamente' : 'negativamente'
      } a DAI`}
      closeButtonText="Cancelar"
      actionButtonText="Avaliar"
      actionButton={onSubmit}
      loading={loading}
    >
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
        <Box>
          <Typography gutterBottom>
            Você está prestes a avaliar essa interação&nbsp;
            <strong
              style={{
                color: isPositiveFeedback
                  ? theme.palette.success.main
                  : theme.palette.error.main,
              }}
            >
              {isPositiveFeedback ? 'positivamente' : 'negativamente'}
            </strong>
          </Typography>
          <Typography variant="body2" gutterBottom>
            Seu feedback é muito importante para que possamos melhorar nossas
            respostas e tornar suas próximas interações ainda melhores.
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            Conte para nós o motivo da sua avaliação:
          </Typography>
          <TextField
            multiline
            minRows={4}
            maxRows={8}
            fullWidth
            value={messageFeedback}
            onChange={handleChangeFeedback}
          />
        </Box>
      </Box>
    </BaseDialog>
  )
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  feedback: PropTypes.string.isRequired,
  setFeedbackSubmitted: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
}

export default ConfirmationDialog
